import { Shadows } from "@mui/material";

// MUI shadows are defined as an array of CSS box-shadow values, where each index represents a different shadow "level" or "depth".
// The shadows array contains 25 values (indices 0-24), with index 0 being "none" and indices 1-24 representing increasing shadow intensities.
// https://mui.com/system/shadows/

export const lightShadows: Shadows = [
  "none", // 0
  "0 0 10px 0 rgba(7, 23, 61, 0.1)", // 1
  "0 0 20px 0 rgba(7, 23, 61, 0.1)", // 2
  "0 0 30px 0 rgba(7, 23, 61, 0.1)", // 3
  "0 0 40px 0 rgba(7, 23, 61, 0.1)", // 4
  "0 0 50px 0 rgba(7, 23, 61, 0.1)", // 5
  "0 0 60px 0 rgba(7, 23, 61, 0.1)", // 6
  "0 0 70px 0 rgba(7, 23, 61, 0.1)", // 7
  "0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)", // 8
  "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)", // 9
  "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)", // 10
  "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)", // 11
  "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)", // 12
  "0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)", // 13
  "0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)", // 14
  "0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)", // 15
  "0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)", // 16
  "0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)", // 17
  "0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)", // 18
  "0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)", // 19
  "0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)", // 20
  "0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)", // 21
  "0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)", // 22
  "0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)", // 23
  "0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)", // 24
];

export const darkShadows: Shadows = [
  "none", // 0
  "0 0 10px 0 rgba(7, 34, 40, 1)", // 1
  "0 0 20px 0 rgba(7, 34, 40, 1)", // 2
  "0 0 30px 0 rgba(7, 34, 40, 1)", // 3
  "0 0 40px 0 rgba(7, 34, 40, 1)", // 4
  "0 0 50px 0 rgba(7, 34, 40, 1)", // 5
  "0 0 60px 0 rgba(7, 34, 40, 1)", // 6
  "0 0 70px 0 rgba(7, 34, 40, 1)", // 7
  "none", // 8
  "none", // 9
  "none", // 10
  "none", // 11
  "none", // 12
  "none", // 13
  "none", // 14
  "none", // 15
  "none", // 16
  "none", // 17
  "none", // 18
  "none", // 19
  "none", // 20
  "none", // 21
  "none", // 22
  "none", // 23
  "none", // 24
];

// Idea: add factory function that creates shadows based on color
// const colorStore: Record<string, Record<number, string>> = {};

// export function getShadow(params: { index: number; color: string }): string {
//   return lightShadows[index];
// }
